import React, { Component } from "react"
import FormField from "../FormField"
import { InputNumber } from "formik-antd"

export default class Likes extends Component {
  render() {
    return (
      <FormField name={this.props.name || "metadata.likes"} label="Likes">
        <InputNumber
          data-cy="invitation-likes"
          style={{ width: "100%" }}
          size="large"
          placeholder="1000"
        />
      </FormField>
    )
  }
}
